<template>
  <LayoutContainer :props="props">
    <div class="invite-record-card">
      <div class="card-header">
        <span class="card-title">邀请记录</span>
        <div class="card-tip">好友7天内首单确认收货后，奖励红包即时到账</div>
      </div>

      <div class="card-body">
        <VanList
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <RecordCard />
          <RecordCard />
          <RecordCard />
        </VanList>
      </div>
    </div>
  </LayoutContainer>
</template>

<script>
import RecordCard from '@/components/record-card';
import { List } from '@zyf2e/capui-mobile';

export default {
  name: 'kaer-invite-record',
  components: {
    RecordCard,
    VanList: List
  },
  props: {
    props: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [{}, {}, {}]
    };
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.i) this.i++;
        else this.i = 1;
        this.list.push({});
        this.loading = false;
        if (this.i === 2) {
          this.finished = true;
        }
      }, 1000);
    }
  }
};
</script>

<style scoped lang="less">
.invite-record-card {
  width: 100%;
  border-radius: 8px;
  background: #fff;

  .card-header {
    background: #F5F5F5;
    height: 56px;
    padding: 12px;
    border-radius: 8px 8px 0px 0px;
    justify-content: space-between;

    .card-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #595959;
      line-height: 0;
    }

    .card-tip {
      margin-top: 3px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8C8C8C;
    }
  }

  .card-body {
    border-radius: 0px 0px 8px 8px;
  }
}
</style>

<style lang="less">
.van-list__error-text, .van-list__finished-text, .van-list__loading {
  font-size: 12px;
}
</style>
